export default {
  dragZoneText: "Drag & drop the destination here!"
};
